import { trackEmailAddressesEvent } from "../analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackAddressCopied = (location: "edit" | "instructions" | "main") =>
  trackEmailAddressesEvent("Forwarding address copied", {
    location,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackAddModalOpened = () => trackEmailAddressesEvent("Add forwarding address modal opened");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackEditModalOpened = () => trackEmailAddressesEvent("Edit forwarding address modal opened");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackInstructionsOpened = (location: "banner" | "list") =>
  trackEmailAddressesEvent("Forwarding instructions opened", {
    location,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackDeleteModalOpened = () => trackEmailAddressesEvent("Delete forwarding address modal opened");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackLearnMoreClicked = (defaultMailboxUsed: boolean) =>
  trackEmailAddressesEvent("'Learn more' clicked", {
    defaultMailboxUsed,
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackTipFollowed = () => trackEmailAddressesEvent("Forwarding address tip followed");

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const trackTipClosed = () => trackEmailAddressesEvent("Forwarding address tip closed");
